import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root'
})
export class DomainService {

  getCurrentDomainName(): string {
    const origin = window.origin;

    return origin.includes('localhost') ? environment.default_local_url : origin.replace(/(^\w+:|^)\/\//, "");
  }

}
